export var contact = {
    900: '#004F82',
    800: '#006DA1',
    700: '#007EB4',
    600: '#0090C7',
    500: '#009ED4',
    400: '#23AAD9',
    300: '#4BBADD',
    200: '#7CCDE7',
    100: '#AFE1F0',
    50: '#E0F3F9',
};
//# sourceMappingURL=contact.js.map